import { createSlice } from '@reduxjs/toolkit';

const walletSlice = createSlice({
  name: 'wallet',
  initialState: {
    isLoading: false,
    wallet: null,
    selectedProduct: null,
    error: false,
    isRedirecting: true,
  },
  reducers: {
    setWallet(state, action) {
      const wallet = action.payload;
      return {
        ...state,
        wallet,
        isLoading: false,
      };
    },
    getWallet(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    setSelectedProduct(state, action) {
      const selectedProduct = action.payload;
      return {
        ...state,
        selectedProduct,
      };
    },
    setWalletError(state) {
      return {
        ...state,
        isLoading: false,
        error: true,
        wallet: [],
      };
    },
    setWalletIsRedirecting(state, action) {
      const isRedirecting = action.payload;
      return {
        ...state,
        isRedirecting,
      };
    },
  },
});

export const {
  setWallet,
  getWallet,
  setSelectedProduct,
  setWalletError,
  setWalletIsRedirecting,
} = walletSlice.actions;

export default walletSlice.reducer;
